<template>
  <div class="bbjsh-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="打款日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="审核状态">
              <el-select v-model="searchForm.type" style="width: 130px" @keyup.enter.native="Search" clearable>
                <el-option label="待审核" :value="1" />
                <el-option label="审核通过" :value="2" />
                <el-option label="审核拒绝" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search()">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="pringLoading" @click="Print">打印对账单</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  @row-click="openDetails"
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%">
                  <el-table-column
                    label="报备金名称"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.delname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报备金额"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.amount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报备订单"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      共 <b>{{scope.row.num}}</b> 订单
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报备要求"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.per}}/单
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="有效期"
                    width="200"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.starttime}} ~ {{scope.row.endtime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="打款日期"
                    width="130"
                    align="center"
                    prop="receipttime"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.username}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请时间"
                    width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报备金名称"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="warning">待审核</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2">审核通过</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">审核拒绝</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="报备金详情"
      :visible.sync="viewVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="viewLoading">
        <tr>
          <th>申请人</th>
          <td>{{ viewdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewdata.delname }}</td>
          <th style="width: 100px">报备金名称</th>
          <td colspan="3" style="color:#000;">{{ viewdata.name }}</td>
        </tr>
        <tr>
          <th>报备要求</th>
          <td>
            {{viewdata.per}}/单
          </td>
          <td colspan="4">
            同比享受最低折扣不低于 {{viewdata.mindiscount}} 折
          </td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewAddress">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.address }}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span><i class="el-icon-date"></i> {{viewdata.starttime}} ~ {{viewdata.endtime}}</span>
            <span style="color:#F56C6C;margin-left: 20px"><i class="el-icon-warning-outline"></i> {{viewdata.endtime}} 之后报备金所剩余额将自动放入账户余额</span>
          </td>
        </tr>
        <tr>
          <th>对应折扣</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewDiscount">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.starttime }} 至 {{ d.endtime }}</td>
                <td style="width: 100px;text-align: center">{{ d.discount }}折</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5">{{ viewAcccount.groupname }}（{{ viewAcccount.name }}，{{ viewAcccount.card }}）</td>
        </tr>
        <tr>
          <th>打款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.amount }}</td>
          <th>打款日期</th>
          <td>{{ viewdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewdata.nature }}</td>
        </tr>
        <tr>
          <th>报备凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewdata.remark }}</td>
        </tr>
        <tr  v-if="viewdata.mark===0||viewdata.mark===2">
          <th>审核人</th>
          <td>{{ viewdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewdata.audittime }}</td>
        </tr>
        <tr v-if="viewdata.mark===0">
          <th>驳回原因</th>
          <td colspan="5">{{ viewdata.rson }}</td>
        </tr>
        <tr v-if="viewdata.mark===1&&viewdata.rson!=''&&viewdata.rson!=null">
          <th>上次驳回</th>
          <td colspan="5" style="color:#f56c6c">{{ viewdata.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="viewdata.mark===1" :loading="auditLoading" size="small" @click="audit(1)">审核通过</el-button>
        <el-button type="danger" v-if="viewdata.mark===1" :loading="auditLoading" size="small" @click="audit(0)">审核驳回</el-button>
        <el-button size="small" @click="viewVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerAccountReportApplyList, getDealerAccountReportById, reviewDealerAccountReport, printBbjStatementList } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'bbjsh',
  computed: {
    user: getUser
  },
  data() {
    return {
      viewVisible: false,
      viewLoading: false,
      imgSrcList: [],
      viewdata: [],
      viewAddress: [],
      viewDiscount: [],
      viewAcccount: [],
      pringLoading: false,
      searchForm: {
        search: '',
        time: null,
        type: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      auditLoading: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const data = {
        mark: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        startTime: startTime,
        endTime: endTime
      }
      getDealerAccountReportApplyList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.imgSrcList = []
      this.viewVisible = true
      this.viewLoading = true
      getDealerAccountReportById({ darid: row.darid }).then(response => {
        this.viewLoading = false
        this.viewdata = response.data.dar
        this.viewAddress = response.data.daralst
        this.viewDiscount = response.data.dardlst
        this.viewAcccount = response.data.acccount
        let imgs = []
        for (let c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgSrcList = imgs
      }).catch(() => {
        this.viewLoading = false
      })
    },
    audit(n) {
      if (this.auditLoading) {
        return false
      }
      if (n === 0) {
        this.$prompt('请输入驳回原因', '审核驳回-报备金申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '驳回原因不可为空'
        }).then(({ value }) => {
          this.auditLoading = true
          reviewDealerAccountReport({ userid: this.user.dUserid, darid: this.viewdata.darid, ispass: n, reason: value }).then(response => {
            this.auditLoading = false
            this.viewVisible = false
            this.$message({
              message: '报备金审核已驳回',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.auditLoading = false
          })
        }).catch(() => {})
      } else {
        this.$confirm('此操作将通过此次报备金申请?', '审核通过-报备金申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auditLoading = true
          reviewDealerAccountReport({ userid: this.user.dUserid, darid: this.viewdata.darid, ispass: n }).then(response => {
            this.auditLoading = false
            this.viewVisible = false
            this.$message({
              message: '报备金审核已通过',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.auditLoading = false
          })
        }).catch(() => {})
      }
    },
    Print() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (!this.pringLoading) {
          let starttime = ''
          let endtime = ''
          if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
            if (this.searchForm.time.length === 2) {
              starttime = this.searchForm.time[0]
              endtime = this.searchForm.time[1]
            }
          }
          if (this.total > 400) {
            if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
              if (this.searchForm.time.length !== 2) {
                this.$message({
                  message: '由于数据量过多，请选择打款日期区间再打印',
                  type: 'warning'
                })
                return false
              }
            } else {
              this.$message({
                message: '由于数据量过多，请选择打款日期区间再打印',
                type: 'warning'
              })
              return false
            }
          }
          let startTime2 = ''
          let endTime2 = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime2 = this.searchForm.time[0]
            endTime2 = this.searchForm.time[1]
          }
          this.pringLoading = true
          const data = {
            mark: this.searchForm.type,
            content: this.searchForm.search,
            groupid: this.user.dGroupid,
            startTime: startTime2,
            endTime: endTime2
          }
          printBbjStatementList(data).then(response => {
            this.pringLoading = false
            LODOP.PRINT_INIT('收款对账单打印')
            LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4')
            LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
            LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
            LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
            LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
            LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
            LODOP.NewPageA()
            LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
            LODOP.PREVIEW()
          }).catch(() => {
            this.pringLoading = false
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bbjsh-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
